"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var star = function (props) {
    var colorPrimary = props.colorPrimary, colorSecondary = props.colorSecondary;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { stroke: colorPrimary, fill: colorSecondary, d: "M75.51 89.967l-4.872-28.405 20.638-20.115L62.755 37.3 50 11.459l-12.755 25.84-28.521 4.148 20.638 20.115-4.872 28.405L50 76.557z", fillRule: "evenodd", strokeOpacity: ".2" })));
};
exports.default = star;
//# sourceMappingURL=star.js.map